export enum DinnerChoice {
  Beef = "Beef",
  Chicken = "Chicken",
  Fish = "Fish",
  Vegan = "Vegan",
  None = "None",
}
